import React from 'react';
import SettingsApprovalRulesContainer from '../../components/modules/Settings/ApprovalRules';

const SettingsApprovalRules = () => {
  return <SettingsApprovalRulesContainer />;
};

export default SettingsApprovalRules;
